<div [ngClass]="{'survey-cancel-modal': isSurveyCancelModal}">
    <div class="model">
        <div class="model-body" [ngClass]="{projectConfirm : projectCSS}">
            <div class="close-modal-survey" *ngIf="isSurveyCancelModal">
                <a (click)="closeConfirmationBox(true)">
                    <i class="fas fa-times close"></i>
                </a>
            </div>
            <div class="content-modal-survey">
                <div *ngIf="isSurveyCancelModal">
                    <i class="far fa-exclamation-triangle alert-icon"></i>
                </div>
                <div class="header box-header">
                    {{title}}
                </div>
                <div class="model-content">
                    <div class="condition-container">
                        <div class="condition">
                            {{message}}
                        </div>
                        <div class="condition">
                            {{submessage}}
                        </div>
                        <div class="button-container" *ngIf="!isSurveyCancelModal">
                            <button type='button' class="btn btn-success confirm-btn"
                                (click)="closeConfirmationBox(true)">Yes</button> &nbsp;
                            <button class="btn btn-danger confirm-btn" (click)="closeConfirmationBox(false)">No</button>
                        </div>
                        <div class="button-container-survey-cancel" *ngIf="isSurveyCancelModal">
                            <button class="btn btn-danger delete" (click)="closeConfirmationBox(false)">Delete</button> &nbsp;
                            <button class="btn kpmg-button--flat" (click)="closeConfirmationBox(true)">Go Back</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>